<template>
  <div>
    <Form @submit="savePayInfo">
      <Divider content-position="left">订单状态</Divider>
      <Field label="支付状态" label-width="4.4em">
        <template #input>
          <RadioGroup v-model="payStatus" direction="horizontal">
            <Radio name="0">Unpaid</Radio>
            <Radio name="1">Paid</Radio>
          </RadioGroup>
        </template>
      </Field>
      <Field label="考试状态" label-width="4.4em">
        <template #input>
          <RadioGroup
            v-model="taskStatus"
            direction="horizontal"
            :disabled="true"
          >
            <Radio name="0">Will</Radio>
            <Radio name="1">Doing</Radio>
            <Radio name="2">Done</Radio>
          </RadioGroup>
        </template>
      </Field>
      <Field>
        <template #input>
          <Button
            size="small"
            type="success"
            color="#292827"
            round
            block
            native-type="submit"
            >保存订单状态</Button
          >
        </template>
      </Field>
    </Form>
  </div>
</template>
<script setup>
import { computed } from "vue";
import { Button, Field, Divider, RadioGroup, Radio, Form, Notify } from "vant";
import { useOrder } from "@/composables/useOrder";
const { orderData, saveOrder } = useOrder();
// const VanNotify = Notify.Component;
const payStatus = computed({
  get: () => {
    if (orderData.value.payStatus === undefined) {
      return "0";
    }
    return orderData.value.payStatus.toString();
  },
  set: (value) => {
    orderData.value.payStatus = parseInt(value);
  },
});
const taskStatus = computed({
  get: () => {
    if (orderData.value.taskStatus === undefined) {
      return "0";
    }
    return orderData.value.taskStatus.toString();
  },
});

// 密码
let AuthorizationCode = sessionStorage.getItem("AuthorizationCode");
// console.log(AuthorizationCode);
const savePayInfo = () => {
  const { payStatus } = orderData.value;
  saveOrder({ payStatus }, AuthorizationCode)
    .then((res) => {
      Notify({ type: "success", message: res });
    })
    .catch((res) => {
      Notify({ type: "warning", message: res });
    });
};
</script>
